import React, { useEffect } from 'react';

import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import MainPage from './Elements/MainPage';
import Projects from './Elements/Projects/Projects';
import Grid from './Elements/Projects/components/Grid';
import SingleView from './Elements/Projects/components/SingleView';
import Detail from './Elements/Projects/Detail';
import LegacyRedirect from './Elements/Projects/LegacyRedirect';
import Info from './Elements/Info/info';
import Layout from './Elements/Layout/Layout';

import './css/App.css';

const GlobalHeader = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <header className="header" style={isHome ? { backgroundColor: '#0d0303' } : {}}>
      <div className="header-container">
        <div className="personal-info">
          <h3 style={isHome ? { color: '#ffffff' } : {}}>⛅️ Xiaoyun ZHONG</h3>
        </div>
        <div className="navigation_container" style={isHome ? { backgroundColor: '#0d0303' } : {}}>
          <ul>
            <li><Link to="/" className="a" style={isHome ? { color: '#ffffff' } : {}}>Home</Link></li>
            <li><Link to="/project" className="a" style={isHome ? { color: '#ffffff' } : {}}>Projects</Link></li>
            <li><Link to="/info" className="a" style={isHome ? { color: '#ffffff' } : {}}>Info</Link></li>
          </ul>
        </div>
      </div>
    </header>
  );
};

const App = () => {

  useEffect(() => {

    document.body.classList.remove('loading');

    const alphaBannerObserver = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const alphaBanner = document.querySelector('.vAygCK-api-load-alpha-banner');
                if (alphaBanner) {
                    alphaBanner.style.display = 'none';
                    observer.disconnect();
                }
            }
        }
    });

    const alphaBannerConfig = { childList: true, subtree: true };
    alphaBannerObserver.observe(document.body, alphaBannerConfig);

    return () => {
        alphaBannerObserver.disconnect();
    };
}, []);

  return (
    <Router>
      <GlobalHeader />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/info" element={<Layout><Info /></Layout>} />
        <Route path="/project" element={<Layout><Projects /></Layout>}>
          <Route index element={<Grid />} />
          <Route path=":slug" element={<SingleView />} />
          <Route path=":slug/view" element={<Detail />} />
        </Route>
        {/* Legacy redirects for old numeric URLs */}
        <Route path="/detail/:id" element={<LegacyRedirect target="view" />} />
      </Routes>
    </Router>
  );
}

const AppWithProviders = () => (
      <App />
);

export default AppWithProviders;
